import React, { useState, useEffect } from 'react';
import { Chart } from "react-google-charts";
import RichTable from '../components/richTable/RichTable.jsx'
import AlgoQuickManage from '../manage/AlgoQuickManage.js';
import AlgoDrawer from '../algos/AlgoDrawer.js'
import DatePicker from "react-datepicker"
import AlgoStatsTooltip from '../components/AlgoStatsTooltip.js'
import { Link } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import AlgoFinder from './AlgoFinder';
import tableHelpers from '../helpers/TableHelpers.js'
import StockQuickLookDrawer from '../stock/StockQuickLookDrawer.js'



function AlgoTimePeriods(props) {

    const [allocations, setAllocations] = useState([]);
    const [startDate, setStartDate] = useState(new Date(new Date().setFullYear(new Date().getFullYear() - 1)));
    const [endDate, setEndDate] = useState(new Date());
    const [drilldownStartDate, setDrilldownStartDate] = useState(null);
    const [drilldownEndDate, setDrilldownEndDate] = useState(null);
    const [results, setResults] = useState(null);
    const [isDrilldownOpen, setIsDrilldownOpen] = useState(false);
    const [useLiveTrades, setUseLiveTrades] = useState(false);
    const [showAll, setShowAll] = useState(false);
    const [showUnrealized, setShowUnrealized] = useState(true);
    const [showCharts, setShowCharts] = useState(true);
    const [chartView, setChartView] = useState('all');


    useEffect(() => {
        (async function () {
            let allocationsText = await (await fetch(`/api/algos?planId=` + props.planId + `&years=5` + (showAll ? `&showAll=1` : ""))).json();
            setAllocations(allocationsText);

            // get the unique algoId's from allocations
            let algoIds = allocationsText.map(a => a.algoId);

            let resultsText = await (await fetch(`/api/algoPerformanceByPeriod?algoIds=` + algoIds.join(',') + `&startDate=` + getDateString(startDate) + `&endDate=` + getDateString(endDate) + `&liveTradesOnly=` + (useLiveTrades ? "1" : "0") + `&showAll=` + (showAll ? "1" : "0") + `&showUnrealized=` + (showUnrealized ? "true" : "false"))).json();
            console.log("results", resultsText);
            setResults(resultsText);
        })();
    }, [props.planId, startDate, endDate, useLiveTrades, showAll, showUnrealized]);


    function getDateString(date) {
        return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    }


    function algoFormatter(cell, row) {
        let algoId = Number(cell);
        let allocation = allocations.find(a => a.algoId === algoId);
        if (allocation)
            return (
                <div className='sameline'>
                    {allocation ? "🚨" : null}<AlgoDrawer tab="backtesttrades" link={allocation.display_name} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={algoId} role={props.role} />
                    &nbsp;<AlgoQuickManage role={props.role} algoId={row.algoId} planId={props.planId} />
                    &nbsp;<AlgoStatsTooltip algoId={row.algoId} />
                </div>
            );
        else
            return null;
    }

    function symbolFormatter(cell, row) {
        let algoId = Number(cell);
        let allocation = allocations.find(a => a.algoId === algoId);
        if (allocation)
            return <StockQuickLookDrawer planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} symbol={allocation.trade_symbol} role={props.role} />;
        else
            return null;
    }

    function getRows() {
        if (results) {
            let rows = [];
            let firstResult = results[Object.keys(results)[0]];
            let algoIds = Object.keys(firstResult);
            let dates = Object.keys(results);
            algoIds.forEach(algoId => {
                let row = {
                    algoId: algoId,
                    total: 0
                }
                dates.forEach(date => {
                    let val = results[date][algoId] !== undefined ? results[date][algoId] : 0;
                    row[date] = val;
                    row.total += val;
                })
                rows.push(row);
            })
            return rows;

        } else {
            return []
        }
    }

    function getColumns() {
        if (results) {
            let min = Infinity;
            let max = -Infinity;
            Object.values(results).forEach(dateObj => {
                Object.values(dateObj).forEach(val => {
                    if (val < min) min = val;
                    if (val > max) max = val;
                });
            });

            let columns = [{ title: 'Algo', field: 'algoId', formatter: algoFormatter, filter: 'text' },
            { title: 'Symbol', field: 'algoId', formatter: symbolFormatter, filter: 'text', sorters: true }
            ];
            Object.keys(results).forEach(date => {
                const [year, month, day] = date.split('-');
                const colStart = new Date(year, Number(month) - 1, day);
                const colEnd = new Date(year, Number(month), day);
                const headerLink = (
                    <span style={{ display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                        <span>{date.trim()}</span>
                        <Link
                            style={{ marginLeft: '4px', textDecoration: 'none', fontSize: '0.85em', cursor: 'pointer' }}
                            title="View active trades for this month"
                            onClick={(e) => {
                                e.stopPropagation();
                                setDrilldownStartDate(colStart);
                                setDrilldownEndDate(colEnd);
                                setIsDrilldownOpen(true);
                            }}
                        >
                            🔍
                        </Link>
                    </span>
                );

                columns.push({
                    title: headerLink,
                    field: date,
                    formatter: tableHelpers.percentFormatterOneDecimal,
                    sorters: true,
                    bgcolor: (cell) => {
                        if (cell == null || isNaN(cell)) return undefined;
                        const val = Number(cell);
                        if (val > 0) {
                            const intensity = max > 0 ? val / max : 0;
                            const other = Math.floor(255 * (1 - Math.min(intensity, 1)));
                            return `rgb(${other}, 255, ${other})`;
                        } else if (val < 0) {
                            const intensity = min < 0 ? val / min : 0;
                            const other = Math.floor(255 * (1 - Math.min(intensity, 1)));
                            return `rgb(255, ${other}, ${other})`;
                        }
                        return undefined;
                    }
                });
            })

            columns.push({
                title: 'Total',
                field: 'total',
                formatter: tableHelpers.percentFormatterOneDecimal,
                sorters: true,
                bgcolor: (cell) => {
                    if (cell == null || isNaN(cell)) return undefined;
                    const val = Number(cell);
                    if (val > 0) return 'rgba(0, 255, 0, 0.2)';
                    if (val < 0) return 'rgba(255, 0, 0, 0.2)';
                    return undefined;
                }
            });

            columns.sort((a, b) => {
                if (a.field === 'algoId' && b.field === 'algoId') return 0;
                if (a.field === 'algoId') return -1;
                if (b.field === 'algoId') return 1;
                if (a.field === 'total' && b.field === 'total') return 0;
                if (a.field === 'total') return 1;
                if (b.field === 'total') return -1;
                return new Date(a.field) - new Date(b.field);
            })
            return columns;
        } else
            return []
    }

    function getYearList() {
        const startYear = 2011;
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let y = startYear; y <= currentYear; y++) {
            years.push(y);
        }
        return years;
    }

    function handleYearClicked(year) {
        setStartDate(new Date(year, 0, 1));
        setEndDate(new Date(year, 11, 31));
    }

    function getBreakdownData() {
        if (!results || !allocations || allocations.length === 0) {
            return { bySymbol: [], byAlgoType: [], byCombo: [] };
        }

        const dateKeys = Object.keys(results);
        if (dateKeys.length === 0) {
            return { bySymbol: [], byAlgoType: [], byCombo: [] };
        }

        const firstResult = results[dateKeys[0]];
        if (!firstResult) {
            return { bySymbol: [], byAlgoType: [], byCombo: [] };
        }

        const algoIds = Object.keys(firstResult);

        // Sum total profit per algoId across all dates in results
        const profitByAlgo = {};
        algoIds.forEach((id) => {
            let sum = 0;
            dateKeys.forEach((d) => {
                const val = results[d]?.[id];
                if (typeof val === 'number') {
                    sum += val;
                }
            });
            profitByAlgo[id] = sum;
        });

        const symbolMap = {};
        const typeMap = {};
        const comboMap = {};

        algoIds.forEach((id) => {
            const alloc = allocations.find((a) => String(a.algoId) === String(id));
            // Prioritize base symbol (not trade_symbol)
            const symbol = (alloc?.symbol || alloc?.trade_symbol || 'Unknown').trim();
            const algoType = (alloc?.algo_type || 'Unknown').trim();
            const combo = `${symbol} - ${algoType}`;
            const profit = profitByAlgo[id] || 0;

            symbolMap[symbol] = (symbolMap[symbol] || 0) + profit;
            typeMap[algoType] = (typeMap[algoType] || 0) + profit;
            comboMap[combo] = (comboMap[combo] || 0) + profit;
        });

        const formatChartData = (categoryName, map) => {
            const sorted = Object.entries(map).sort((a, b) => b[1] - a[1]);
            const rows = sorted.map(([name, profit]) => {
                const formatted = `${profit >= 0 ? '+' : ''}${profit.toFixed(1)}%`;
                const color = profit >= 0 ? '#28a745' : '#dc3545';
                return [name, Number(profit.toFixed(2)), color, formatted];
            });
            return [
                [categoryName, 'Profit %', { role: 'style' }, { role: 'annotation' }],
                ...rows,
            ];
        };

        return {
            bySymbol: formatChartData('Symbol', symbolMap),
            byAlgoType: formatChartData('Algo Type', typeMap),
            byCombo: formatChartData('Symbol & Type', comboMap),
        };
    }

    function getChartOptions(title, hAxisTitle) {
        return {
            title,
            titleTextStyle: { fontSize: 13, bold: true, color: '#333' },
            legend: { position: 'none' },
            chartArea: { width: '85%', height: '65%', top: 35, bottom: 65 },
            hAxis: {
                title: hAxisTitle,
                slantedText: true,
                slantedTextAngle: 30,
                textStyle: { fontSize: 11 },
                titleTextStyle: { fontSize: 11, italic: false, bold: true },
            },
            vAxis: {
                title: 'Total Profit %',
                format: '#,##0.0',
                textStyle: { fontSize: 11 },
                titleTextStyle: { fontSize: 11, italic: false, bold: true },
            },
            annotations: {
                alwaysOutside: true,
                textStyle: { fontSize: 10, bold: true, color: '#222' },
            },
        };
    }

    const breakdownData = getBreakdownData();
    const hasChartData =
        breakdownData.bySymbol.length > 1 ||
        breakdownData.byAlgoType.length > 1 ||
        breakdownData.byCombo.length > 1;

    return (
        <>
            <div>

                <div style={{ padding: '20px' }}>
                    <center>
                        Start: <DatePicker className="bg-transparent" selected={startDate} onChange={(date) => setStartDate(date)} />
                        &nbsp;&nbsp;
                        End: <DatePicker className="bg-transparent" selected={endDate} onChange={(date) => setEndDate(date)} />
                        &nbsp;&nbsp;
                        <input type="checkbox" checked={useLiveTrades} disabled={showUnrealized} onChange={() => setUseLiveTrades(!useLiveTrades)} /> Live Trades Only
                        &nbsp;&nbsp;
                        <input type="checkbox" checked={showAll} onChange={() => setShowAll(!showAll)} /> Show All
                        &nbsp;&nbsp;
                        <input type="checkbox" checked={showUnrealized} disabled={useLiveTrades} onChange={() => setShowUnrealized(!showUnrealized)} /> Show Unrealized
                        <br></br>
                        <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: '6px' }}>
                            <span style={{ fontWeight: 'bold', marginRight: '4px' }}>Years:</span>
                            {getYearList().map((yr) => {
                                const isSelected =
                                    startDate &&
                                    endDate &&
                                    startDate.getFullYear() === yr &&
                                    startDate.getMonth() === 0 &&
                                    startDate.getDate() === 1 &&
                                    endDate.getFullYear() === yr;
                                return (
                                    <Link
                                        key={yr}
                                        style={{
                                            padding: '2px 8px',
                                            borderRadius: '4px',
                                            textDecoration: isSelected ? 'none' : 'underline',
                                            fontWeight: isSelected ? 'bold' : 'normal',
                                            backgroundColor: isSelected ? '#007bff' : 'transparent',
                                            color: isSelected ? '#ffffff' : '#007bff',
                                            cursor: 'pointer',
                                            fontSize: '0.9em',
                                        }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleYearClicked(yr);
                                        }}
                                    >
                                        {yr}
                                    </Link>
                                );
                            })}
                        </div>
                    </center>

                    {hasChartData && (
                        <div style={{ marginTop: '25px', marginBottom: '25px' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginBottom: '14px', flexWrap: 'wrap' }}>
                                <span style={{ fontWeight: 'bold', fontSize: '0.9em', color: '#495057' }}>Profit Breakdown:</span>
                                {[
                                    { id: 'all', label: 'All Breakdowns' },
                                    { id: 'symbol', label: 'By Symbol' },
                                    { id: 'algo_type', label: 'By Algo Type' },
                                    { id: 'combo', label: 'By Symbol & Algo Type' },
                                ].map((tab) => {
                                    const isTabSelected = chartView === tab.id;
                                    return (
                                        <button
                                            key={tab.id}
                                            type="button"
                                            style={{
                                                padding: '3px 12px',
                                                borderRadius: '4px',
                                                border: '1px solid #007bff',
                                                backgroundColor: isTabSelected ? '#007bff' : 'transparent',
                                                color: isTabSelected ? '#ffffff' : '#007bff',
                                                cursor: 'pointer',
                                                fontSize: '0.85em',
                                                fontWeight: isTabSelected ? 'bold' : 'normal',
                                                transition: 'all 0.15s ease-in-out',
                                            }}
                                            onClick={() => {
                                                setChartView(tab.id);
                                                if (!showCharts) setShowCharts(true);
                                            }}
                                        >
                                            {tab.label}
                                        </button>
                                    );
                                })}
                                <button
                                    type="button"
                                    style={{
                                        padding: '3px 10px',
                                        borderRadius: '4px',
                                        border: '1px solid #6c757d',
                                        backgroundColor: 'transparent',
                                        color: '#6c757d',
                                        cursor: 'pointer',
                                        fontSize: '0.85em',
                                        marginLeft: '6px',
                                    }}
                                    onClick={() => setShowCharts(!showCharts)}
                                >
                                    {showCharts ? 'Hide Charts' : 'Show Charts'}
                                </button>
                            </div>

                            {showCharts && (
                                <div>
                                    {(chartView === 'all' || chartView === 'symbol' || chartView === 'algo_type') && (
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginBottom: chartView === 'all' ? '16px' : '0' }}>
                                            {(chartView === 'all' || chartView === 'symbol') && (
                                                <div style={{ flex: chartView === 'all' ? '1 1 420px' : '1 1 100%', minWidth: '300px', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '12px', backgroundColor: '#ffffff', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
                                                    <h5 style={{ textAlign: 'center', marginBottom: '6px', fontSize: '0.95rem', fontWeight: 'bold', color: '#2d3748' }}>
                                                        Profit by Symbol
                                                    </h5>
                                                    {breakdownData.bySymbol.length > 1 ? (
                                                        <Chart
                                                            chartType="ColumnChart"
                                                            width="100%"
                                                            height={chartView === 'all' ? '280px' : '340px'}
                                                            data={breakdownData.bySymbol}
                                                            options={getChartOptions('Profit by Symbol', 'Base Symbol')}
                                                        />
                                                    ) : (
                                                        <div style={{ textAlign: 'center', padding: '40px', color: '#a0aec0' }}>No symbol data</div>
                                                    )}
                                                </div>
                                            )}

                                            {(chartView === 'all' || chartView === 'algo_type') && (
                                                <div style={{ flex: chartView === 'all' ? '1 1 420px' : '1 1 100%', minWidth: '300px', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '12px', backgroundColor: '#ffffff', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
                                                    <h5 style={{ textAlign: 'center', marginBottom: '6px', fontSize: '0.95rem', fontWeight: 'bold', color: '#2d3748' }}>
                                                        Profit by Algo Type
                                                    </h5>
                                                    {breakdownData.byAlgoType.length > 1 ? (
                                                        <Chart
                                                            chartType="ColumnChart"
                                                            width="100%"
                                                            height={chartView === 'all' ? '280px' : '340px'}
                                                            data={breakdownData.byAlgoType}
                                                            options={getChartOptions('Profit by Algo Type', 'Algorithm Type')}
                                                        />
                                                    ) : (
                                                        <div style={{ textAlign: 'center', padding: '40px', color: '#a0aec0' }}>No algo type data</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {(chartView === 'all' || chartView === 'combo') && (
                                        <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '12px', backgroundColor: '#ffffff', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
                                            <h5 style={{ textAlign: 'center', marginBottom: '6px', fontSize: '0.95rem', fontWeight: 'bold', color: '#2d3748' }}>
                                                Profit by Symbol & Algo Type Combination
                                            </h5>
                                            {breakdownData.byCombo.length > 1 ? (
                                                <Chart
                                                    chartType="ColumnChart"
                                                    width="100%"
                                                    height={chartView === 'all' ? '320px' : '380px'}
                                                    data={breakdownData.byCombo}
                                                    options={getChartOptions('Profit by Symbol & Algo Type', 'Symbol - Algo Type')}
                                                />
                                            ) : (
                                                <div style={{ textAlign: 'center', padding: '40px', color: '#a0aec0' }}>No combination data</div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                    {results ?
                        <RichTable showTotalRow={true} enableExport={true} data={getRows()} className="table-striped table-hover table-condensed" mappers={
                            getColumns()
                        } />
                        :
                        null}
                </div>

                <Drawer
                    anchor={'bottom'}
                    open={isDrilldownOpen}
                    onClose={() => setIsDrilldownOpen(false)}
                >
                    <div style={{ padding: '10px' }}>
                        <center><b><Link onClick={() => setIsDrilldownOpen(false)}>Close</Link></b></center>
                        <br></br>
                        <h4>Active Trades</h4>
                        <AlgoFinder role={props.role} user={props.user} mobileView={props.mobileView} planId={props.planId} startDate={drilldownStartDate} endDate={drilldownEndDate} />
                    </div>
                </Drawer >

            </div >
        </>
    );
}

export default AlgoTimePeriods; 